
















import Vue from "vue";

// Model
import InstalledSoftwaresTable from "@/views/App/ServiceAndUpdates/UpdatesManagement/DetailsSection/InstalledSoftwaresTable.vue";
import AgentInfoPropsList from "@/components/PropsLists/AgentInfoPropsList.vue";
import { UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";

export default Vue.extend({
    components: {
        AgentInfoPropsList,
        InstalledSoftwaresTable,
    },
    props: ["installation", "installationUpdate"],
    computed: {
        installedSoftwaresVersions() {
            if (this.installationUpdate.installedSoftwaresVersions.length > 0)
                return this.installationUpdate.installedSoftwaresVersions.filter((u) => u.updateType != UpdateTypeEnum.CustomAction);
            return [];
        },
        availableSoftwareVersionsToUpgrade() {
            if (this.installationUpdate.availableSoftwareVersionsToUpgrade.length > 0)
                return this.installationUpdate.availableSoftwareVersionsToUpgrade.filter((u) => u.updateType != UpdateTypeEnum.CustomAction);
            return [];
        },
        associatedCustomActions() {
            if (this.installationUpdate.installedSoftwaresVersions.length > 0)
                return this.installationUpdate.installedSoftwaresVersions.filter((u) => u.updateType == UpdateTypeEnum.CustomAction).concat(this.availableCustomActions);
            return [];
        },
        availableCustomActions() {
            if (this.installationUpdate.availableSoftwareVersionsToUpgrade.length > 0)
                return this.installationUpdate.availableSoftwareVersionsToUpgrade.filter((u) => u.updateType == UpdateTypeEnum.CustomAction);
            return [];
        },
    },
});
